'use strict';
const angular = require('angular');

/*@ngInject*/
export function ForumService($resource) {
  return $resource('/api/posts/:id', {
    id: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    queryByCategory: {
      method: 'GET',
      url: "/api/posts/category/:cat",
      isArray: true
    },
    queryMessages: {
      method: 'GET',
      url: "/api/posts/:id/messages",
      isArray: true
    },
    getMessage: {
      method: 'GET',
      url: "/api/posts/:id/messages/:msgid",
    },
    createMessage: {
      method: 'POST',
      url: "/api/posts/:id/messages"
    },
    updateMessage: {
      method: 'PUT',
      url: "/api/posts/:id/messages/:msgid"
    },
    deleteMessage: {
      method: 'DELETE',
      url: "/api/posts/:id/messages/:msgid",
    }
  });
}


export default angular.module('conduuApp.ForumService', [])
  .factory('ForumService', ForumService)
  .name;



// WEBPACK FOOTER //
// ./client/services/forum/forum.service.js